import { useState, useCallback } from 'react';
import { IBookmark } from '@/common/types/IBookmark';
import { WebMetadataService } from '../utilities/network/WebMetadataService';

export function useUrlMetadata() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [metadata, setMetadata] = useState<Partial<IBookmark> | undefined>(undefined);

  const fetchMetadata = useCallback(async (url: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await WebMetadataService.extractMetadata(url);
      setMetadata(data);
      return data;
    } catch (err) {
      setError('Failed to fetch URL metadata');
      console.error('Error fetching URL metadata:', err);
      return undefined;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    metadata,
    fetchMetadata,
  };
}
